export const FALLBACK_LOCAL_STORAGE_KEY = "dummy-stateful-tab";
export const DEFAULT_TAB = 0;
